import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PoojaCard from '../components/PoojaCard';
import SearchBar from '../components/SearchBar';
import LoadingOverlay from '../components/LoadingOverlay';
import QuickBookingModal from '../components/QuickBookingModal';
import { Container, Grid, Typography, Box, Button } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import LandingPage from '../components/LandingPage';
const Home = ({ category }) => {
    const [poojaList, setPoojaList] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [quickBookingOpen, setQuickBookingOpen] = useState(false);
    const [quickBookingType, setQuickBookingType] = useState('booking');
    const [quickBookingPooja, setQuickBookingPooja] = useState('');
    const apiUrl = process.env.REACT_APP_API_URL;
    useEffect(() => {
        setLoading(true);
        axios
            .get(`${apiUrl}/poojas`, {  headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
          'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY
    }})
            .then((response) => {
                const list = response.data?.filter((item) => item['sl_no'] && item?.pooja_name);
                setPoojaList(list);
            })
            .catch((error) => console.error(error))
            .finally(() => setLoading(false));
    }, [apiUrl]);

    const filteredPoojas = poojaList.filter((pooja) => {
        const matchesSearch = searchQuery
            ? pooja.pooja_name?.toLowerCase().includes(searchQuery.toLowerCase())
            : true;

const excludedPoojas = ['Homa', 'Bali', 'Shanti', 'Parayana', 'Pooja', 'Vrata'];
        const matchesCategory = category !=='' && category !=='All'
            ? category === 'Special Occasion'
                ? !excludedPoojas.some(excluded => pooja.pooja_name.toLowerCase().includes(excluded.toLowerCase()))
                : pooja.pooja_name?.toLowerCase().includes(category.toLowerCase())
            : true;

        return matchesSearch && matchesCategory;
    });

    const openQuickBooking = (requestType, poojaName = '') => {
        setQuickBookingType(requestType);
        setQuickBookingPooja(poojaName);
        setQuickBookingOpen(true);
    };

    return (
        <>
         {(category === '' || category === 'All') && (!searchQuery || searchQuery.length === 0) && (
             <LandingPage onBookFeaturedPuja={() => openQuickBooking('booking', 'Navaratri Puja Parayana')} />
         )}
        <Container maxWidth="lg" sx={{ marginTop: '20px' }}>
            <LoadingOverlay open={loading} message="Loading poojas..." />
            <Typography
                variant="h4"
                gutterBottom
                align="center"
                sx={{ color: '#a52a2a', fontWeight: 'bold' }}
            >
                {category ? `${category} Poojas` : 'Explore Our Poojas'}
            </Typography>
            {(category === '' || category === 'All') && !searchQuery && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'center',
                        gap: 2,
                        mb: 3,
                    }}
                >
                    <Button
                        variant="outlined"
                        color="error"
                        size="large"
                        onClick={() => openQuickBooking('guidance')}
                        sx={{ borderRadius: 3, px: 3, py: 1.25, fontWeight: 700 }}
                    >
                        Guide Me
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        size="large"
                        onClick={() => openQuickBooking('booking')}
                        sx={{ borderRadius: 3, px: 3, py: 1.25, fontWeight: 700 }}
                    >
                        Book Now
                    </Button>
                </Box>
            )}
            <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
            
            {filteredPoojas.length > 0 ? (
                <Grid container spacing={4}>
                    {filteredPoojas.map((pooja, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <PoojaCard pooja={pooja} />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '400px',
                        textAlign: 'center',
                        gap: 3,
                        py: 5,
                    }}
                >
                    <SearchOffIcon
                        sx={{
                            fontSize: '80px',
                            color: '#d4af8f',
                            opacity: 0.5,
                        }}
                    />
                    <Box>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 'bold',
                                color: '#333',
                                mb: 1,
                            }}
                        >
                            No Poojas Found
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                color: '#666',
                                mb: 2,
                            }}
                        >
                            We couldn't find the pooja you're looking for. Don't worry! You can
                            request a custom pooja and we'll get back to you shortly.
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        color="error"
                        size="large"
                        onClick={() => openQuickBooking('booking')}
                        sx={{
                            px: 4,
                            py: 1.5,
                            fontSize: '16px',
                            fontWeight: 'bold',
                        }}
                    >
                        Request Pooja
                    </Button>
                </Box>
            )}

            <QuickBookingModal
                open={quickBookingOpen}
                onClose={() => setQuickBookingOpen(false)}
                poojaName={quickBookingPooja}
                requestType={quickBookingType}
            />
        </Container>
        </>
    );
};

export default Home;
